import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Client } from './client';

@Injectable()
export class UsersService {



  constructor(
    private http: HttpClient,
    private client: Client,
  ) { }

  getServicesList(): Observable<any> {
    return this.http.get(this.client.getServicesUrl());
  }

  getRolesList(): Observable<any> {
    return this.http.get(this.client.getRolesUrl());
  }

  getUserRolesList(id): Observable<any> {
    return this.http.get(this.client.getUserRolesUrl({ 'id': id }));
  }

  getUsers(): Observable<any> {
    return this.http.get(this.client.getUserListUrl());
  }

  addUser(user): Observable<any> {
    return this.http.post(this.client.getUsersUrl(), user)
  }

  editUser(user): Observable<any> {
    return this.http.put(this.client.getUsersUrl(), user)
  }

  addService(id, service): Observable<any> {
    if (service)
      return this.http.put(this.client.getUsersServiceUrl(), { user_id: id, service_id: service })
  }

  removeService(id, service): Observable<any> {
    if (service)
      return this.http.delete(this.client.getUsersServiceUrl(), { params: new HttpParams({ fromObject: { user_id: id, service_id: service } }) });
  }

  addRoles(id, roles): Observable<any> {
    if (roles[0])
      return this.http.put(this.client.getUserRolesUrl(), { id: id, roles: roles })
  }

  removeRoles(id, roles): Observable<any> {
    if (roles[0])
      return this.http.delete(this.client.getUserRolesUrl(), { params: new HttpParams({ fromObject: { id: id, 'roles[]': roles } }) })
  }

  addUserRole(data): Observable<any> {
    return this.http.put(this.client.getUserRolesUrl(), data);
  }

  deleteUser(id): Observable<any> {
    return this.http.delete(this.client.getUsersUrl({ 'id': id }));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/users.service.ts